/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![InstagramNeutralIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACW0lEQVR4nN1VS2sUQRAe36KGNTcfKIIgeFFPetxTYHGmq2oOnaokwkIOe8lFRV097UEC+SX+i2hCjIgH9RdE0WgExWeUqGikZrqTyUxvGPQUC/pSVV1fV31VXVH034m1tgHE1w3JPSBZBOL3+ZHVjYeXMz3KkiGZT5CvAcDApsERR8/lQcvBpN5Bfm6MnOkTvH3QBzfETwAEEPlYHI8O6omiaFv5TpIk+xD5BICkgHI/vyvPhoYu7a8AGJJbLvjjTqezq25JAeQCpDIB4+MDgPwgywTkSghgPjOmEtcNrmKQ37l7E4jMLovZqCxA/MahHynbDDEC8owjdlkbAHHEZPeQ7wDxW6KR80R8yvGxGACQr2rUupb0U5sQOxngUcv8IQSwosZWq7Vnw8tJVg3Kd4NyQ7PTY5C7qnPBEu+v5PoWDgH8VGOz2dy5pkMtiwJwt1I25K6r912v08e5zFZCAL/VWGxHg/JFdWk6drjsf9HaQw7gs9f1er3t7kG/KgCqVKM6lQEgQHwc26OuHJ9qAuQ1tdbuXtNR9l0ESwTEN930Tnudzo/nrFYXaSuuk8zdEMnFuWm223ud/7dQBh9dBo0S8GS/NjXIt4u+vouKvKwDkLzIM7DHqzZOtFuUk4wX5OnQxBPxybxsslQtkWtJ/eSivxRI2Tpe5qoZ6CDl6E+LRNcVvWOIH7rOuhpyaBjklx5Ep7j4XVtrdxRr7fVEfBrS4TFAeeS4WbDWHgi+Ik6Hz/7TwiFZ6Ltwih9WthuQ5wzya12LBvlHYGVmq9QQv9Lv2aBcDi6aLS9/ALtnuBUobTC2AAAAAElFTkSuQmCC)
 */
export const InstagramNeutralIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M7 12a5 5 0 1 1 10 0 5 5 0 0 1-10 0Zm5-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M17.25 8a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M7.86 2.07a7.3 7.3 0 0 0-2.43.47A4.9 4.9 0 0 0 3.66 3.7a4.9 4.9 0 0 0-1.15 1.77 7.35 7.35 0 0 0-.46 2.43C2.01 8.96 2 9.3 2 12.02c0 2.71.02 3.06.07 4.12.05 1.07.22 1.8.47 2.43.26.66.6 1.21 1.16 1.77.55.55 1.11.9 1.77 1.15.64.24 1.36.41 2.43.46 1.06.04 1.4.05 4.12.05 2.71 0 3.06-.02 4.12-.07a6.14 6.14 0 0 0 4.2-1.63 6.15 6.15 0 0 0 1.6-4.2c.05-1.06.06-1.4.06-4.12 0-2.71-.02-3.05-.07-4.12a6.15 6.15 0 0 0-1.63-4.2 6.14 6.14 0 0 0-4.2-1.6C15.04 2 14.7 2 11.98 2c-2.71 0-3.05.02-4.12.07Zm.1 2c-.88.04-1.39.17-1.8.33a2.9 2.9 0 0 0-1.08.7 2.9 2.9 0 0 0-.7 1.09c-.16.4-.29.92-.33 1.8A68.6 68.6 0 0 0 4 12.01c0 2.7.02 3 .07 4.03.04.87.17 1.38.33 1.79.17.42.36.73.7 1.08.35.34.67.54 1.09.7.41.16.92.29 1.8.33 1.01.04 1.32.05 4.03.05 2.7 0 3-.02 4.03-.07 1.28-.06 2.23-.4 2.87-1.04.64-.64.97-1.6 1.03-2.87.04-1.02.05-1.33.05-4.04 0-2.7-.02-3-.07-4.03-.06-1.28-.4-2.23-1.04-2.87-.64-.64-1.6-.97-2.87-1.03A69.44 69.44 0 0 0 11.98 4c-2.7 0-3 .02-4.02.07Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
